import React, {FC} from 'react';
import classNames from 'classnames';
import Icon from 'components/Icon';
import {Search} from 'modules/search-popup/components/Search';
import {HeaderRightButtons} from './HeaderRightButtons';
import style from '../style.module.scss';
import {useSinglePageRoutes} from 'core/modules/routing/hooks/useSinglePageRoutes';
import Link from 'components/CustomRoutingLink';
import {NEXT_PUBLIC_WINTER_DESIGN} from 'core/helpers/env';
import {ButtonNew} from 'components/ButtonNew';

interface IHeaderBottomProps {
    isSearchPanelVisible: boolean;
    isMenuOpen: boolean;
    handleCatalogClick: () => void;
    setIsSearchPanelVisible: (state: boolean) => void;
    menu: React.ReactElement;
}

export const HeaderBottom: FC<IHeaderBottomProps> = ({
    isSearchPanelVisible,
    isMenuOpen,
    handleCatalogClick,
    setIsSearchPanelVisible,
    menu,
}) => {
    const {
        main: {url: indexUrl},
    } = useSinglePageRoutes();

    return (
        <div
            className={classNames(style.headerBottom, {
                [style.isSearchOpen]: isSearchPanelVisible,
            })}
        >
            <div className={style.headerBottomLeftSide}>
                <div className={classNames(style.headerBottomWrapper)}>
                    <Link className={classNames(style.headerBottomWrapperLink, 'logo logo--middle')} href={indexUrl()}>
                        <div className={style.logoLg}>
                            <Icon icon={'logo'} />
                        </div>
                        <div className={style.logoSm}>
                            <Icon icon={'logo-sm'} />
                        </div>
                    </Link>
                </div>
                <ButtonNew
                    className={classNames(style.headerBottomCatalogButton, 'page-header__catalog-btn', {
                        [style.headerBottomCatalogButtonClicked]: isMenuOpen,
                        // NEW_YEAR_2026
                        ['header-menu-button-winter-design']: NEXT_PUBLIC_WINTER_DESIGN,
                    })}
                    data-autotest-target={'header-ecom'}
                    data-autotest-target-id={'header-ecom-catalog-btn'}
                    onClick={handleCatalogClick}
                    leftIcon={<Icon icon={isMenuOpen ? 'close' : 'catalog'} width={24} height={24} />}
                    variant={'large'}
                    textClassName={style.catalogName}
                    // NEW_YEAR_2026
                    isWinterDesign={true}
                >
                    Каталог
                </ButtonNew>
                <div
                    className={classNames(style.headerBottomSearchFieldItem, {
                        [style.headerSearchOpenModal]: isSearchPanelVisible,
                    })}
                >
                    <Search
                        className={style.headerBottomSearchField}
                        dataAutotestTarget={'header-search'}
                        isNeedClose={true}
                        isPanelVisible={isSearchPanelVisible}
                        setIsPanelVisible={setIsSearchPanelVisible}
                    />
                </div>
                <div className={classNames(style.headerBottomWrapper, style.hiddenContainerSm)}>
                    <HeaderRightButtons />
                </div>
                {menu}
            </div>
        </div>
    );
};
